<template>
  <form id="form-add-event" class="position-relative" @submit.prevent="submit">
    <loader :loading="loadingForm" block />

    <v-card>
      <v-card-title class="headline grey lighten-2 mb-4 justify-center" primary-title>
        Добавить документ
      </v-card-title>

      <v-card-text class="py-1">
        <v-autocomplete
          label="Тип документа"
          hide-no-data
          hide-selected
          item-text="name"
          item-value="id"
          v-model="form.category"
          :loading="loadingTypes"
          :items="eventsTypes"
          :error-messages="typeErrors"
          @change="categorySelect"
        >
        </v-autocomplete>
      </v-card-text>

      <template v-if="formFields.length">
        <v-divider class="mt-4 mb-0"></v-divider>

        <v-card-text class="py-1">
          <dynamic-form ref="dynamic" :value="dynamicForm" :schema="formFields" @input="updateDynamicForm" />
        </v-card-text>
      </template>

      <v-divider class="mt-4"></v-divider>

      <v-card-actions>
        <v-btn id="form-add-event-cancel" color="primary" text @click="close">Отменить</v-btn>
        <v-spacer></v-spacer>
        <v-btn id="form-add-event-submit" type="submit" color="primary" text>
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { messageHelper } from "@/services/validation-helper";
import Loader from "@/components/Loader";
import DynamicForm from "@/modules/documents/add-document/DynamicForm.vue";
import { uniqueId } from "lodash/util";
import { formModal } from "@/mixins/modal/form-modal";
import { API_ERROR_MESSAGE } from "@/config";
import asFormData from "json-form-data";

/**
 * Копия компонента AddDocument, нужно подумать как объединить общие части
 */
export default {
  name: "AddEvent",

  components: { DynamicForm, Loader },

  mixins: [formModal],

  props: {
    date: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    loadingForm: false,

    loadingTypes: false,
    eventsTypes: [],
    formFields: [],

    form: {
      author: "",
      category: "",
    },

    dynamicForm: {
      name: "",
      real_date: "",
    },
  }),

  validations: {
    form: {
      category: { required },
    },
  },

  computed: {
    typeErrors() {
      return messageHelper(this.$v.form.category);
    },
  },

  async created() {
    this.dynamicForm.real_date = this.$props.date;
    await this.loadData();
  },

  methods: {
    async loadData() {
      this.loading(true);

      try {
        const response = await this.$http.get(`v1/documents/types`, { params: { lang: "ru" } });
        this.eventsTypes = response.data.success ? response.data.data : [];
      } catch (e) {
        this.$notify.showMessage(e.response.message || API_ERROR_MESSAGE, "error");
      }

      this.loading(false);
    },

    async categorySelect(categoryId) {
      this.loading(true);

      try {
        const response = await this.$http.get(`v1/documents/types/${categoryId}/fields`, { params: { lang: "ru" } });

        if (response.data.success) {
          this.formFields = response.data.data.map(item => ({ uuid: uniqueId(), ...item }));
        }
      } catch (e) {
        this.$notify.showMessage(e.response.message || API_ERROR_MESSAGE, "error");
      }

      this.loading(false);
    },

    /**
     * Хендлер для обновление полей динамической формы
     *
     * @param formData
     */
    updateDynamicForm(formData) {
      this.dynamicForm = formData;
    },

    async submit() {
      this.$v.form.$touch();

      if (this.$v.form.$pending || this.$v.form.$error) return;
      if (this.$refs.dynamic && this.$refs.dynamic.isInvalid()) return;

      this.loading(true);

      try {
        const form = {
          ...this.form,
          ...this.dynamicForm,
          author: this.$store.state.auth.id,
        };

        const response = await this.$http.post(`v1/customers/${this.$store.state.customer.id}/documents`, asFormData(form), {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.data.success) {
          this.$store.commit("ikp/ADD_AGENDA", response.data.data);
          this.$store.commit("ikp/ADD_CALENDAR", response.data.data);
          this.$notify.showMessage(response.data.message, "success");
          this.close();
        }
      } catch (e) {
        this.$notify.showMessage(e.response.message || API_ERROR_MESSAGE, "error");
      }

      this.loading(false);
    },
  },
};
</script>

<style scoped></style>
